var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 27L23 19L15 27",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19V37",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7828 31.779C41.7335 30.7155 43.2745 29.0328 44.1626 26.9962C45.0507 24.9597 45.2353 22.6855 44.6873 20.5324C44.1392 18.3793 42.8898 16.47 41.1362 15.1059C39.3826 13.7418 37.2246 13.0005 35.0028 12.999H32.4828C31.8775 10.6575 30.7492 8.48366 29.1827 6.64098C27.6163 4.79829 25.6525 3.33469 23.439 2.36021C21.2256 1.38572 18.8199 0.925709 16.4031 1.01476C13.9862 1.1038 11.621 1.73959 9.4852 2.87432C7.34942 4.00905 5.49867 5.6132 4.07209 7.56616C2.64551 9.51911 1.68023 11.7701 1.24881 14.1498C0.81739 16.5295 0.931061 18.9761 1.58128 21.3055C2.23149 23.635 3.40133 25.7867 5.00285 27.599",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27L23 19L15 27",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8e3706278d5d46a88654904e9f4bf492.svg";
export { ForwardRef as ReactComponent };